module.exports = __webpack_public_path__ + "static/media/progressBarLvl3.ef89a767.svg";